import { getURL, initiateTableLoading } from './helpers/pagination';
import { getSortingOrder, toggleTableHeaderSorter } from './helpers/sorter';
import { getTableHeaderSorter } from './helpers/dom';

const orderSwitchSelector = '.comparison-table__orderSwitch';

function onColumnSort(table, { item }) {
  const parent = table.parentNode;
  const mobileDropdown = parent.querySelector(orderSwitchSelector);
  const [selectedItem] = item || [];

  if (mobileDropdown && selectedItem) {
    mobileDropdown.dataset.sortBy = selectedItem.innerText;
  }
}

function combineColumnAndOrder(column = '', order = '') {
  return `${column.toUpperCase()} ${order.toUpperCase()}`;
}

function registerPaginationTableSorter(table, comparisonWrapper) {
  if (!table || !comparisonWrapper) return;

  function handleColumnSort({ target, detail }) {
    const tableToSort = target;
    const { column, order } = detail;
    const { paginationNav: count } = tableToSort.dataset;
    const resetOffsetToStart = 0;

    if (!column || !order || !count) return;

    const sort = combineColumnAndOrder(column, order);
    const url = getURL(comparisonWrapper.dataset, resetOffsetToStart, count, sort);

    if (url) {
      tableToSort.dataset.ajaxTableSorting = sort;
      initiateTableLoading(tableToSort);
      fetch(url)
        .then(response => response.json())
        .then((response) => {
          tableToSort.dispatchEvent(new CustomEvent('update-paginated-table', {
            detail: response,
          }));
          onColumnSort(tableToSort, detail);
        });
    }
  }

  function handleTableColumnSort({ target: currentTableHeader }) {
    const { ajaxTableSorterColumn: column } = currentTableHeader.dataset;
    const order = getSortingOrder(currentTableHeader);

    toggleTableHeaderSorter(table, currentTableHeader, order);
    handleColumnSort({ target: table, detail: { column, order } });
  }

  [...getTableHeaderSorter(table)]
    .forEach(tableHeader => tableHeader.addEventListener('click', handleTableColumnSort));

  table.addEventListener('order-switch-click', handleColumnSort);

  table.addEventListener('ajax-sortEnd', ({ target, detail }) => onColumnSort(target, detail));
}

export {
  registerPaginationTableSorter,
};
